import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Select,
  Stack,
  MenuItem,
  Divider,
  FormHelperText,
} from '@mui/material';
import StationSelector from '@components/common/station-selector/station-selector.tsx';
import { useContext } from 'react';
import {
  IStationSwitcherContext,
  StationSwitcherContext,
} from '@components/providers/station/context.tsx';
const countries = ['MEX', 'CHL', 'COL', 'PER'];

const ModalStationSelector = () => {
  const {
    visible,
    temporal,
    desTemporal,
    onConfirmStation,
    onChangeStation,
    onChangeDestStation,
    onChangeCountry,
    currentCountry,
  } = useContext<IStationSwitcherContext>(StationSwitcherContext);

  return (
    <Dialog
      aria-labelledby="station-selector-title"
      aria-describedby="station-selector-description"
      disableEscapeKeyDown={true}
      maxWidth={'xs'}
      fullWidth
      open={visible}
    >
      <DialogTitle id="station-selector-title">
        Por favor indique su estación
      </DialogTitle>
      <DialogContent style={{ paddingTop: 8 }}>
        <Stack
          direction="column"
          alignContent="center"
          justifyItems="center"
          spacing={2}
        >
          <FormHelperText>
            <strong>Selecciones su País</strong>
          </FormHelperText>
          <Select
            fullWidth
            value={currentCountry}
            onChange={onChangeCountry}
            label="País"
            displayEmpty
            renderValue={(value) => value || 'País'}
          >
            {countries.map((country) => (
              <MenuItem key={country} value={country}>
                {country}
              </MenuItem>
            ))}
          </Select>

          <Divider />
          <FormHelperText>
            <strong>Estaciones disponibles</strong>
          </FormHelperText>

          {currentCountry && (
            <>
              <StationSelector
                currenCountry={currentCountry}
                label={'Estación donde se encuentra'}
                hint={
                  'Al inducir paquetes y calcular primera milla se tomará en cuenta esta estación'
                }
                station={temporal}
                onChange={onChangeStation}
                disabled={false}
                isOutlined
              />

              <StationSelector
                currenCountry={currentCountry}
                label={'Estación de ruta'}
                hint={
                  'Al planificar rutas y configurar zonas se tomará en cuenta esta estación'
                }
                station={desTemporal}
                onChange={onChangeDestStation}
                disabled={false}
                isOutlined
              />
            </>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          disableElevation={true}
          disabled={!temporal || !desTemporal}
          onClick={onConfirmStation}
          autoFocus
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { ModalStationSelector };
